import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  mode: 'rules',
  rules: {
    values: [
      {
        outputName: '',
        conditions: {
          conditions: [
            { leftValue: '', operator: 'equals', rightValue: '' }
          ],
        },
        conditionCombinator: 'and',
      },
    ],
  },
  numberOfOutputs: 4,
  outputExpression: '',
  options: {
    fallbackOutput: 'none',
    ignoreCase: false,
    sendToAll: false,
  },
};

export default defaults;
